const axios = require('axios').default;
const config = require('@/config/config.json');

const sdk = class sdk {

    constructor({ pid, onUnauthorized }) {
        let apidomain = config.api.domain;
        this.domain = `${apidomain}/iv/1/providers/${pid}`;
        this.onUnauthorized = onUnauthorized;
        //instance.defaults.headers.common['Authorization'] = 'Bearer ' + token; //con un interceptor
    }

    async getChallenge(chid) {
        try {
            let domain = this.domain;
            let response = await axios.get(`${domain}/challenges/${chid}`);
            //console.log(response.data.data.items);
            return response.data.data.items[0];
        } catch (err) {

            if (this.onUnauthorized) this.onUnauthorized();
        }
    }

    async getChallenges() {
        try {
            let domain = this.domain;
            let response = await axios.get(`${domain}/challenges`);
            //console.log(response.data.data.items);
            return response.data.data.items;
        } catch (err) {
            console.log(err);
            if (this.onUnauthorized) this.onUnauthorized();
        }
    }

    async getIdeas(chid) {
        try {
            let domain = this.domain;
            let response = await axios.get(`${domain}/challenges/${chid}/ideas`);
            //console.log(response.data.data.items);
            return response.data.data.items;
        } catch (err) {
            if (this.onUnauthorized) this.onUnauthorized();
        }
    }

    async getIdea(iid) {
        try {
            let domain = this.domain;
            let response = await axios.get(`${domain}/ideas/${iid}`);
            //console.log(response.data.data.items);
            return response.data.data.items[0];
        } catch (err) {
            if (this.onUnauthorized) this.onUnauthorized();
        }
    }

    async postIdea(chid, title, description, uid, uname) {
        try {
            let domain = this.domain;
            let response = await axios.post(`${domain}/ideas`,
                {
                    chid,
                    title,
                    description,
                    uid,
                    uname
                });
            return response;
        } catch (err) {
            if (this.onUnauthorized) this.onUnauthorized();
        }
    }

    async participate(id, type, value) {
        try {

            let body = {
                id,
                type, //view, vote_down, vote_up
                value
            };
            let domain = this.domain;
            await axios.post(`${domain}/participations`, body);
        } catch (err) {
            if (this.onUnauthorized) this.onUnauthorized();
        }
    }

    async getIdeaComments(iid) {
        try {
            return this.api.getIdeaComments(iid);
        } catch (err) {
            if (this.onUnauthorized) this.onUnauthorized();
        }
    }


    async getComments(iid) {
        try {
            let domain = this.domain;
            let response = await axios.get(`${domain}/ideas/${iid}/comments`);
            //console.log(response.data.data.items);
            return response.data.data.items;
        } catch (err) {
            if (this.onUnauthorized) this.onUnauthorized();
        }
    }

    async getParticipation(id, type) {
        try {
            let domain = this.domain;
            let response = await axios.get(`${domain}/participations/${id}/${type}`);
            let d = response.data.data.items.length > 0 ? response.data.data.items[0] : null;

            return d;
        } catch (err) {
            if (this.onUnauthorized) this.onUnauthorized();
        }
    }

    async postComment(iid, text, uid, uname) {
        try {
            let domain = this.domain;
            let response = await axios.post(`${domain}/comments`,
                {
                    iid,
                    text,
                    uid,
                    uname
                });
            return response;
        } catch (err) {
            if (this.onUnauthorized) this.onUnauthorized();
        }
    }
}

module.exports = sdk;